<template>
    <section :class="[namespace(), skinStyle]">
        <div
            :class="[
                mdsNS('form__select form__select--small'),
                namespace('wrap')
            ]"
        >
            <select
                :class="[mdsNS('form__select-input'), namespace('wrap-input')]"
                v-model="value"
                @change="change"
            >
                <option
                    :class="[
                        mdsNS('form__select-option'),
                        namespace('wrap-option')
                    ]"
                    v-for="item in dataModel"
                    :key="item.id"
                    :value="item.id"
                    :selected="item.selected"
                >
                    {{ item.name }}
                </option>
            </select>
            <div :class="mdsNS('form__select-visual-wrap')"></div>
            <span :class="mdsNS('form__select-open-indicator')">
                <svg
                    :class="mdsNS('icon form__select-open-icon')"
                    aria-hidden="true"
                >
                    <use xlink:href="#caret-down--s"></use>
                </svg>
            </span>
        </div>
    </section>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-select',
    mixins: [mixins],
    props: {
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.namespace = utils.namespace('ui-select', false);
    },

    watch: {
        dataModel: function(value) {
            const selected = utils.find(this.dataModel, item => item.selected);
            this.value = selected ? selected.id : '';
        }
    },
    methods: {
        change(e) {
            const id = e.target.value;
            this.$emit(
                'change',
                utils.find(this.dataModel, item => item.id === id)
            );
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-select';
.#{$namespace} {
    font-family: $mds-font-family-sans-serif;
    &-wrap {
        z-index: 1;
        width: 100%;
        &-input-options {
            font-family: $mds-font-family-sans-serif;
            font-size: 14px;
        }
    }
    &.mds-container--dark-gray {
        background: $mds-background-color-dark-gray;
        color: $mds-text-color-primary-on-dark;
        border-bottom-color: $mds-color-neutral-20;
        font-family: $mds-font-family-sans-serif;
        .#{$namespace}-wrap {
            &-option {
                background: $mds-color-neutral-20;
                color: $mds-text-color-primary-on-dark;
                font-weight: 300;
            }
        }
    }
}
</style>
